import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { LINK_PRICING } from '../../constants/link_constants'

const PricingListView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FP_PRICING)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const roundValues = ({ text }) => (
    <div style={{ textAlign: 'center' }}>
      <span>{text && text > 0 ? parseFloat(text).toString() : '-'}</span>
    </div>
  )

  const textAlignCenter = ({ text }) => (
    <span style={{ textAlign: 'center' }}>{text}</span>
  )

  const boolValues = ({ text }) => (
    <div style={{ textAlign: 'center' }}>
      <span className='one-line-value'>
        <input className="form-check-input" type="checkbox" checked={text && text > 0} disabled />
          &nbsp;<br />
      </span>
    </div>
  )

  const fields = [
    (attr, row, disable) => {
      const detailLink = ({ text }) => (
        <a href='javascript:void(0)' style={{ display: 'block' }} onClick={() => store.detailClicked(row)}>{text}</a>
      )
      return <TextField attr={attr} val={row[attr]} disableValue={disable} Component={!disable ? detailLink : undefined} />
    },
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => (<OptionsField
      attr={attr}
      val={row[attr]}
      options={store.options.get('VodSaleTypes')}
      labelattr='text'
      valueattr='value' />),
    (attr, row) => (row[attr]
      ? <DateField attr={attr} val={row[attr]} valN={row.valid_to} showTime />
      : <TextField attr={attr} val={'-'} />),
    (attr, row) => (row[attr]
      ? <DateField attr={attr} val={row[attr]} valN={row.valid_from} showTime />
      : <TextField attr={attr} val={'-'} />),
    (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
    (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
    (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
    (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
    (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
    (attr, row) => (<TextField attr={attr} val={row[attr] || '-'} Component={textAlignCenter} />),
    (attr, row) => (<TextField attr={attr} val={row[attr] ? row[attr].toLowerCase() : '-'} />),
    (attr, row) => (<TextField attr={attr} val={row[attr] || '-'} Component={boolValues} />),
    (attr, row) => (<TextField
      attr={attr} val={row[attr] || '-'}
      options={store.options.get('Countries')} labelattr='text'
      popoverText={row[attr] && row[attr].replace(/,/g, ', ')} />),
    (attr, row) => (<TextField attr={attr} val={row[attr] || '-'} options={store.options.get('ContractCurrency')} labelattr='text' />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  const enums = new Map()
  enums.set('days', [
    { value: 'day', text: 'day' },
    { value: 'week', text: 'week' },
    { value: 'month', text: 'month' },
    { value: 'year', text: 'year' }
  ])
  enums.set('bool', [
    { value: '0', text: 'false' },
    { value: '1', text: 'true' }
  ])

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    platform_enumtext: {
      component: (props) => (<SelectInput
        {...props}
        optionsrecord={store.options}
        labelattr='text'
        valueattr='text'
        optionsattr={'FlyPrivatePlatforms'} />)
    },
    tier_enumtext: {
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='text' optionsattr={'PricingTiers'} />)
    },
    type_sale: {
      title: 'Sale type',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'VodSaleTypes'} />)
    },
    valid_from__from: {
      component: (props) => (
        <div style={{ width: '155px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    valid_to__from: {
      component: (props) => (
        <div style={{ width: '155px' }}>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    utc_flag: {
      component: (props) => (<SelectInput {...props} optionsrecord={enums}
        labelattr='text' valueattr='value' optionsattr={'bool'} />)
    },
    quality_mobile_price_like: {
      component: (props) => (<TextInput {...props} />)
    },
    quality_sd_price_like: {
      component: (props) => (<TextInput {...props} />)
    },
    quality_hd_price_like: {
      component: (props) => (<TextInput {...props} />)
    },
    qquality_uhd_price_like: {
      component: (props) => (<TextInput {...props} />)
    },
    period_length_like: {
      component: (props) => (<TextInput {...props} />)
    },
    period_time_unit: {
      component: (props) => (<SelectInput {...props} optionsrecord={enums}
        labelattr='value' optionsattr={'days'} />)
    },
    coming_soon_flag: {
      component: (props) => (<SelectInput {...props} optionsrecord={enums}
        labelattr='text' valueattr='value' optionsattr={'bool'} />)
    },
    regions_like: {
      component: (props) => (<TextInput {...props} />)
    },
    currency_cd: {
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'ContractCurrency'} />)
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_PRICING)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />
  )
}
export default observer(PricingListView)
